import { Component, Switch, Match, Show } from "solid-js";
import { session } from "./app";
import { A } from "./components/universal/a-href";
import { Img } from "./components/universal/image";
import { Artwork, ArtworkImage, NewImage } from "./types";
import { cleanImagePath } from "./api";

type Props = {
    artwork: Artwork;
}

export const ArtworkImageSection : Component<Props> = ({ artwork }) => {
    const loadImage = (image: NewImage) => {
        const imageZoomUrl = `/Common/Image?imageId=${image.id}&artworkId=${artwork.id}`;
        window.location.href = imageZoomUrl;
    };
    const megapixels = (height: number|undefined, width: number|undefined) => {
        if (!height || !width) return "";
        const mp = Math.round(height * width / 1000000);
        return mp < 1 ? "about 1 megapixel" : mp > 1 ? mp + " megapixels" : "1 megapixel";
    }
    const megabytes = (bytes: number|undefined) => {
        if (!bytes) return "";
        const KB = 1024, MB = KB * KB;
        const value = Math.round(bytes / MB);
        return value < 1 ? "about 1 megabyte" : value > 1 ? value + " megabytes" : "1 megabyte";
    }
    const downloadImage = (image: NewImage) => {
        // if (!!ga) {
        //     ga('send', 'event', 'download', "this.href");
        // }
        window.location.href = cleanImagePath(image.url);
    };
    const canDownload = (artworkImage: ArtworkImage) => {
        return session.isLoggedIn;
    };
    const isHighRes = (artworkImage: ArtworkImage) => {
        return (artworkImage!.newImage!.width || 0) >= 2000
        || (artworkImage!.newImage!.height || 0) >= 2000;
    };
    return (
        <div style="display: inline-block; text-align: left;">
            <div>
                <div style="width: 100%; background-color: #000; text-align: center;">
                    <a onClick={(e) => { e.preventDefault(); loadImage(artwork.primaryImage); }}>
                        <Img
                            src={ artwork.primaryImage.url}
                            alt="Click to zoom"
                            class="artwork-image no-clicky-for-you zoomable"
                            format="JPEG" mode="max" width="800" height="800"
                        />
                    </a>
                </div>
                <div style="background-color: #000; color: #efefef; padding: 10px 0;">
                    <div style="display: inline-block; margin-left: 10px; vertical-align: bottom;">
                        <a style="font-size: 2em; color: #928f7d;" title="Zoom"
                            onClick={(e) => { e.preventDefault(); loadImage(artwork.primaryImage); }}>
                            <span class="fa fa-search-plus"></span>
                        </a>
                    </div>
                    <div style="display: inline-block; margin-left: 5px; vertical-align: bottom;">
                        <p>
                            <a style="color: #efefef; text-decoration: underline;" onClick={(e) => { e.preventDefault(); loadImage(artwork.primaryImage); }}>View</a><br />
                        </p>
                    </div>
                    <div style="display: inline-block; margin-left: 10px; vertical-align: middle;">
                        <p style="margin: 0;">
                            <Switch>
                                <Match when={session.isLoggedIn}>
                                    <Switch>
                                        <Match when={artwork.canOrderPrint && session.member.memberType != "Free"}>
                                            <a style="font-size: 2em; color: #928f7d;" title="Download" onClick={(e) => { e.preventDefault(); downloadImage(artwork.primaryImage); }}>
                                                <span class="fa fa-cloud-download"></span> Download
                                            </a>
                                        </Match>
                                        <Match when={artwork.canOrderPrint && session.member.memberType == "Free"}>
                                            <A 
                                                href="/MyARC/Membership/ManageMembership" parameters={{ "returnUrl": "/artwork/index/" + artwork.id }}
                                                style="font-size: 2em; color: #928f7d;" title="Subscribe to donwload">
                                                Subscribe to download
                                            </A>
                                        </Match>
                                    </Switch>
                                </Match>
                                <Match when={!session.isLoggedIn}>
                                    <Match when={artwork.canOrderPrint}>
                                        <A href="/Home/Login" parameters={{ "returnUrl": "/artwork/index/" + artwork.id }}
                                        style="font-size: 2em; color: #928f7d;" title="Login to download">
                                            Login to download
                                        </A>
                                    </Match>
                                </Match>
                            </Switch>
                        </p>
                    </div>
                    <div style="display: inline-block; margin-left: 5px; font-size: 0.75rem; vertical-align: middle;">
                        <Show when={artwork.isHighRes}>
                            <p style="margin: 5px 0;">
                                <span>
                                    <span style="color: lawngreen;" class="fa fa-check"></span> Hi-res image available
                                </span>
                            </p>
                        </Show>
                    </div>
                    <Show when={artwork.canOrderPrint}>
                        <div style="display: inline-block; margin-left: 10px; vertical-align: bottom;">
                            <A style="font-size: 2em; color: #928f7d;" title="Buy a print" href={ "/Store/OrderPoster/" + artwork.id }>
                                <span class="fa fa-shopping-cart"></span>
                            </A>
                        </div>
                        <div style="display: inline-block; margin-left: 5px; vertical-align: bottom;">
                            <p>
                                <A style="color: #efefef; text-decoration: underline;" href={"/Store/OrderPoster/" + artwork.id}>Buy a print</A><br />
                            </p>
                        </div>
                    </Show>
                    <div style="float: right;">
                        <div style="display: inline-block; margin-right: 5px; font-size: 0.75rem; vertical-align: middle; margin-left: 20px; transform: rotate(-90deg);
    border-bottom: 1px dotted #fff;">
                            <p style="margin: 0;">
                                Image<br/>Details
                            </p>
                        </div>
                        <div style="display: inline-block; width: 125px; font-size: 0.75rem; vertical-align: middle;">
                            <p style="margin: 0;">
                                <span>
                                    {artwork.primaryImage.height} x {artwork.primaryImage.width} pixels
                                </span>
                            </p>
                        </div>
                        <div style="display: inline-block; width: 125px; font-size: 0.75rem; vertical-align: middle;">
                            <p style="margin: 0;">
                                <Show when={artwork.isHighRes}>
                                    <span class="hd">HD</span>  
                                </Show>
                            </p>
                            <div style="margin:0; padding: 0;">
                                {megapixels(artwork.primaryImage.width, artwork.primaryImage.height)}
                                <div style="border-bottom: 1px dotted #fff; margin: 4px 0; width: 70px;"></div>
                                {megabytes(artwork.primaryImage.fileSizeBytes)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}